import VocConsole from "./src/main"

/* istanbul ignore next */
VocConsole.install = function (Vue) {
  Vue.component(VocConsole.name, VocConsole)
}

export default VocConsole
